import { CancelToken } from 'axios'

import { TableUrlParams, TransformArrayBufferResponseType } from 'Core/interfaces'
import { Http } from 'Core/utils'

import { Audit } from 'Portals/Customer/entities'

import { baseUrl } from './constants'

export const getList = (params: TableUrlParams): Promise<ListData<Audit.Basic>> =>
	Http.get(`${baseUrl}`, { params })

export const searchSuggestions = (
	params: TableUrlParams,
	cancelToken?: CancelToken
): Promise<Audit.Search.Result> =>
	Http.get(`${baseUrl}/search-suggestions`, { params, cancelToken })

export const retrieveSuccessfullySavedCount = (): Promise<number> =>
	Http.get(`${baseUrl}/daily-count`)

export const exportAudit = (params: TableUrlParams): Promise<TransformArrayBufferResponseType> =>
	Http.get(`${baseUrl}/export`, {
		params,
		responseType: 'arraybuffer',
		transformResponse: (data: ArrayBuffer, headers) => ({
			data,
			headers
		})
	})

export const retrieveDailyData = (): Promise<Audit.Daily> => Http.get(`${baseUrl}/daily`)
